import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import Modal from '../Modals/Modal';
import { LEAGUE_LIST, UNRANKED_LEAGUE_CONFIG } from 'src/constants/points';
import Text from '../Text/Text';
import { twMerge } from 'tailwind-merge';
import { usePointsStore } from 'src/stores/usePointsStore';
import { getLeagueConfigFromVolume } from 'src/utils/points';

const LeagueRow = ({
	league,
	range,
	isUserCurrentLeague,
	imageUrl,
}: {
	league: string;
	range: string;
	isUserCurrentLeague: boolean;
	imageUrl: string;
}) => {
	return (
		<div
			className={twMerge(
				'flex items-center justify-between py-2',
				isUserCurrentLeague && 'bg-container-bg-selected'
			)}
		>
			<div className="flex items-center gap-[6px]">
				<img
					src={isUserCurrentLeague ? imageUrl : UNRANKED_LEAGUE_CONFIG.imageUrl}
					className={twMerge(
						'h-6',
						isUserCurrentLeague ? 'opacity-100' : 'opacity-50'
					)}
				/>
				<Text.H5
					className={twMerge(
						isUserCurrentLeague ? 'text-text-emphasis' : 'text-text-secondary'
					)}
				>
					{league}
				</Text.H5>
			</div>

			<Text.BODY2
				className={twMerge(
					isUserCurrentLeague ? 'text-text-emphasis' : 'text-text-label'
				)}
			>
				{range}
			</Text.BODY2>
		</div>
	);
};

const LeaguesModal = () => {
	const setDriftStore = useDriftStore((state) => state.set);
	const inProgressTradeVolume = usePointsStore(
		(s) => s.inProgressPointsDrop.tradeVolume
	);

	const currentUserLeague = getLeagueConfigFromVolume(inProgressTradeVolume);

	const onClose = () => {
		setDriftStore((s) => {
			s.modals.showLeaguesModal = false;
		});
	};

	return (
		<Modal onClose={onClose}>
			<Modal.Body>
				<Modal.Header onClose={onClose} showX>
					<Modal.Title>Leagues</Modal.Title>
				</Modal.Header>
				<Modal.Content className="flex flex-col gap-4">
					<div className="flex flex-col divide-y-2 divide-container-bg-hover">
						{LEAGUE_LIST.map((league) => (
							<LeagueRow
								key={league.league}
								league={league.league}
								range={league.range}
								imageUrl={league.imageUrl}
								isUserCurrentLeague={league === currentUserLeague}
							/>
						))}
					</div>

					<div className="flex flex-col gap-1">
						<Text.H5 className="text-text-label">About Leagues</Text.H5>
						<Text.BODY3>
							Leagues are a fun and fair way to distribute additional bonuses
							and rewards to loyal Driftors who help the protocol grow.
							<br />
							<br />
							Leagues are based on total volume and reset each week. Depending
							on the league you reach every week, you’ll be eligible for special
							campaigns that allow you to boost how many points you earn every
							week! <br />
							<br />
							Your League status is recorded and updated with every points drop.
						</Text.BODY3>
					</div>
				</Modal.Content>
			</Modal.Body>
		</Modal>
	);
};

export default LeaguesModal;
